var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09264 21.442L0 24.5346L10.8242 29.1736L15.4654 40L18.558 36.9074L17.0117 29.1736L24.2578 21.9275L32.1534 38.7774L35.082 35.8488L32.4793 13.7082L38.6646 7.52071C39.0824 7.11719 39.4156 6.63451 39.6449 6.10083C39.8741 5.56714 39.9948 4.99314 39.9998 4.41233C40.0049 3.83151 39.8942 3.2555 39.6743 2.71791C39.4543 2.18032 39.1295 1.69192 38.7188 1.28121C38.3081 0.870492 37.8197 0.545685 37.2821 0.325741C36.7445 0.105796 36.1685 -0.004882 35.5877 0.000165159C35.0069 0.00521232 34.4329 0.125884 33.8992 0.355137C33.3655 0.584391 32.8828 0.917635 32.4793 1.33543L26.13 7.68475L3.98938 5.07984L1.22262 7.84878L17.9413 15.8757L10.8264 22.9905L3.09264 21.442V21.442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.d5e9152e6b62c036b6a0bd13d8bb3f84.svg";
export { ForwardRef as ReactComponent };